import React from 'react'
import PropTypes from 'prop-types'

function EmailOutboxPagination({
  startIndex,
  endIndex,
  totalDrafts,
  currentPage,
  totalPages,
  setCurrentPage,
}) {
  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div>
        Showing {startIndex + 1}-{Math.min(endIndex, totalDrafts)} of{' '}
        {totalDrafts}
      </div>
      <div className="btn-group">
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => setCurrentPage((p) => p - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => setCurrentPage((p) => p + 1)}
          disabled={currentPage >= totalPages}
        >
          Next
        </button>
      </div>
    </div>
  )
}

EmailOutboxPagination.propTypes = {
  startIndex: PropTypes.number.isRequired,
  endIndex: PropTypes.number.isRequired,
  totalDrafts: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
}

export default EmailOutboxPagination
